// import Dashboard from "views/example/Dashboard.jsx";
// import Icons from "views/example/Icons.jsx";
// import Map from "views/example/Map.jsx";
// import Notifications from "views/example/Notifications.jsx";
// import TableList from "views/example/TableList.jsx";
// import Typography from "views/example/Typography.jsx";
// import UserProfile from "views/example/UserProfile.jsx";

import Dash from "views/Dash.jsx";
import DataCenter from "views/DataCenter.jsx";
import Insights from "views/Insights.jsx";
import Signup from "views/Signup.jsx";
import Login from "views/Login.jsx";
import Maps from "views/Map.jsx";
import Settings from "views/Settings.jsx";
import Home from "views/Home.jsx";

var routes = [
  {
    path: "/dash",
    name: "Dashboard",
    icon: "tim-icons icon-chart-bar-32",
    component: Dash,
    layout: "/user"
  },
  {
    path: "/datacenter",
    name: "Data Center",
    icon: "tim-icons icon-upload",
    component: DataCenter,
    layout: "/user"
  },
  {
    path: "/map",
    name: "Map",
    icon: "tim-icons icon-square-pin",
    component: Maps,
    layout: "/user"
  },
  {
    path: "/insights",
    name: "Insights",
    icon: "tim-icons icon-bulb-63",
    component: Insights,
    layout: "/user"
  },
  {
    path: "/settings",
    name: "Settings",
    icon: "tim-icons icon-settings",
    component: Settings,
    layout: "/user",
    invisible: false
  },
  {
    path: "/login",
    name: "Login",
    icon: "tim-icons icon-settings",
    component: Login,
    layout: "",
    invisible: true
  },
  {
    path: "/signup",
    name: "SignUp",
    icon: "tim-icons icon-settings",
    component: Signup,
    layout: "",
    invisible: true
  },
  {
    path: "/home",
    name: "Home",
    icon: "tim-icons icon-settings",
    component: Home,
    layout: "",
    invisible: true
  },
  // {
  //   path: "/example/dashboard",
  //   name: "Dashboard",
  //   icon: "tim-icons icon-simple-remove",
  //   component: Dashboard,
  //   layout: "/user",
  //   invisible: true
  // },
  // {
  //   path: "/example/icons",
  //   name: "Icons",
  //   icon: "tim-icons icon-simple-remove",
  //   component: Icons,
  //   layout: "/user",
  //   invisible: true
  // },
  // {
  //   path: "/example/map",
  //   name: "Map",
  //   icon: "tim-icons icon-simple-remove",
  //   component: Map,
  //   layout: "/user",
  //   invisible: true
  // },
  // {
  //   path: "/example/notifications",
  //   name: "Notifications",
  //   icon: "tim-icons icon-simple-remove",
  //   component: Notifications,
  //   layout: "/user",
  //   invisible: true
  // },
  // {
  //   path: "/example/user-profile",
  //   name: "User Profile",
  //   icon: "tim-icons icon-simple-remove",
  //   component: UserProfile,
  //   layout: "/user",
  //   invisible: true
  // },
  // {
  //   path: "/example/tables",
  //   name: "Table List",
  //   icon: "tim-icons icon-simple-remove",
  //   component: TableList,
  //   layout: "/user",
  //   invisible: true
  // },
  // {
  //   path: "/example/typography",
  //   name: "Typography",
  //   icon: "tim-icons icon-simple-remove",
  //   component: Typography,
  //   layout: "/user",
  //   invisible: true
  // }
];
export default routes;
